import { fetchUserByID as fetchUserAPI } from "../api/index.js";

export const fetchUserByID = async (userID) => {
  const res = await fetchUserAPI(userID);
  return res.data;
};
